import React from "react";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
export default function RenderHtmlFormattedText({
  htmlContent,
  text_div_class = "",
}) {
  const safeHtml = DOMPurify.sanitize(htmlContent);

  return (
    <div className={` ${text_div_class} `}>
      {parse(DOMPurify.sanitize(safeHtml))}
    </div>
  );
}
